import React, { useEffect, useState } from "react";
import PreviewContact from "./PreviewContact";
import "./contacts.scss";

import { loadCurrentUser } from "../../store/users";
import { Rings } from "react-loader-spinner";
import { useDispatch, useSelector } from "react-redux";
import Card from "./Card";
import AddContactButton from "./AddContacts";
import { Add } from "@mui/icons-material"; // Updated import
import EditCard from "./EditContact";
import axios from "axios";
import { getUsers, patchUser } from "../../services/users";

export default function Contacts() {
  const dispatch = useDispatch();
  const currentUser = useSelector(
    (state) => state.entities.users.currentUser
  );
  const [users, setusers] = useState(currentUser.contacts);
  const [contacts, setcontacts] = useState([]);
  const [idArray, setidArray] = useState([]);
  const [open, setopen] = useState(false);
  const [loading, setloading] = useState(false);
  const [edit, setedit] = useState({
    contactIndex: -1,
    contact: [],
    isedit: false,
  });

  const [preview, setpreview] = useState({
    contactIndex: -1,
    contact: [],
    ispreview: false,
  });

  const AllContactshandler = async () => {
    setloading(true);
    const { data } = await getUsers();
    setcontacts(data);
    setloading(false);
  };

  useEffect(() => {
    // Dispatch the loadCurrentUser action to fetch the user data
    dispatch(loadCurrentUser(currentUser._id));
  }, []);

  useEffect(() => {
    setusers(currentUser.contacts);
    try {
      AllContactshandler();
    } catch (error) {
      console.log(error);
    }
  }, []);

  const OnlyUsersArray = contacts.map((enteries) => {
    const name =
      enteries?.contactName?.first + " " + enteries?.contactName?.last;
    const email = enteries.email;

    return {
      name,
      email,
    };
  });

  const onAdd = async () => {
    const contactIds = users?.map((e) => e._id);
    let copiedPerson = JSON.parse(JSON.stringify(currentUser));

    copiedPerson["contacts"] = contactIds;

    patchUser(copiedPerson, copiedPerson.imageSrc)
      .then((e) => console.log(e))
      .catch((e) => console.log(e));
  };

  const [shouldCallOnAdd, setShouldCallOnAdd] = useState(false);

  useEffect(() => {
    if (shouldCallOnAdd) {
      onAdd();
      setShouldCallOnAdd(false);
    }
  }, [shouldCallOnAdd]);

  return loading ? (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "50vh",
      }}
    >
      <span>
        <Rings height="150" width="150" radius="50" />
      </span>
    </div>
  ) : (
    <div className="container-fluid">
      <div className="block-header">
        <AddContactButton
          open={open}
          currentUser={currentUser}
          onOpen={() => {}}
          onAdd={() => setShouldCallOnAdd(true)}
          setusers={setusers}
          setAdded={setidArray}
          added={users}
          users={contacts}
          onClose={() => {
            setopen(false);
          }}
        />
        <PreviewContact
          open={preview.ispreview}
          preview={preview}
          onClose={() => {
            setpreview({
              ispreview: false,
              contact: [],
              contactIndex: -1,
            });
          }}
        />
        <div className="row">
          <div className="col-9">
            {/* Contact breadcrumb */}
            <ul className="breadcrumb breadcrumb-style ">
              <li className="breadcrumb-item">
                <h4 className="page-title">Contacts</h4>
              </li>
              <li
                className="breadcrumb-item bcrumb-1"
                onClick={() => {
                  setopen(true);
                }}
                style={{ cursor: "pointer" }}
              >
                New
                <Add />
              </li>
            </ul>
          </div>
          {/* Search Input column */}
          <div className="col-3">
            <input
              type="text"
              className="my-3 form-control"
              placeholder="Search ......"
            />
          </div>
          {users?.map((e, i) => {
            return (
              <Card
                setusers={setusers}
                setedit={setedit}
                setpreview={setpreview}
                preview={preview}
                ondel={() => setShouldCallOnAdd(true)}
                edit={edit}
                users={users}
                key={i}
                index={i}
                setopen={setopen}
                img={e.imageSrc}
                name={`${e.contactName.first} ${e.contactName.last}`}
                address={
                  e.Address.address1 === "undefined"
                    ? "Not Specified"
                    : e.Address.address1
                }
                feedback={e.email}
                status={e.status === null ? "Offline" : e.status}
              />
            );
          })}
        </div>
      </div>

      {edit.isedit && (
        <EditCard
          open={edit.isedit}
          setusers={setusers}
          users={users}
          setedit={setedit}
          contact={edit.contact}
          index={edit.contactIndex}
          onClose={() => {
            setedit({
              contactIndex: -1,
              contact: [],
              isedit: false,
            });
          }}
        />
      )}
    </div>
  );
}
